import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import moment from 'moment'

import { formatCurrency } from '../../../../../../utils/currency'
import { translation } from '../../../../../../utils/helpers'
import { makeOrderAssessmentIcon } from '../../../../../../utils/order'
import UserInfo from '../../../../../../shared/components/UserInfo'

// Elements
import Inline from '../../../../../../shared/elements/inline'
import Icon from '../../../../../../shared/elements/icon'
import LabelWrapper from '../../../../../../shared/elements/labelWrapper'
import HelpIcon from '../../../../../../shared/elements/helpIcon'

// Styles
import '../../index.scss'
import '../index.scss'

class InvoiceLogItem extends PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      item: {
        Type: 0,
        Date: undefined,
        InvoiceNo: null,
        VoucherNo: null,
        VoucherFilePath: '',
        Price: '',
        CompanyName: '',
        UserName: '',
        UserPhone: '',
        UserMail: ''
      }
    }
    this.findLogLineIcon = this.findLogLineIcon.bind(this)
    this.getTextFromType = this.getTextFromType.bind(this)
  }
  componentWillReceiveProps (nextProps) {
    if (nextProps.item !== this.props.item) {
      this.setState({
        item: nextProps.item
      })
    }
  }
  componentDidMount () {
    this.setState({
      item: this.props.item
    })
  }
  findLogLineIcon (key) {
    let icon = ''
    key = '' + key
    switch (key) {
      case '1139': return 'images/svgs/invoicelog/ready-for-invoice.svg'            // '1139' Godkendt til fakturering
      case '13042': return 'images/svgs/invoice/posted-not-billed.svg'              // '13042' Sendt til fakturering
      case '1136': return 'images/svgs/invoice/Payment-ok.svg'                      // '1136' Bogført
      case '14958': return 'images/svgs/invoicelog/crediting.svg'                   // '14958' Kreditering
      case '15322':
      case '15267':
      case '14959': return 'images/svgs/invoice/posted-not-billed.svg'              // '14959' Gensendt til fakturering
      case '14960': return 'images/svgs/invoicelog/credit-note.svg'                 // '14960' Kreditnota
      case '14961': return 'images/svgs/invoicelog/invoice.svg'                     // '14961' Faktura
      case '14962': return 'images/svgs/invoicelog/afterevaluation-sent.svg'        // '14962' Eftertaksering sendt
      case '14963': return 'images/svgs/invoicelog/main-report-received.svg'        // '14963' Hovedrapport modtaget
      case '14916': return 'images/svgs/invoicelog/additional-report-received.svg'  // '14916' Tillægsrapport modtaget
      case '2716': return 'images/svgs/invoicelog/price-change-sent_black.svg'      // '2716'  Prisændring afsendt
      case '14983': return 'images/svgs/taksering/Charging-Black.svg'                // '14983' Omfang oprettet
      case '2714':                                                                  // '2714' Prisændring godkendt
      case '2715': return 'images/svgs/invoicelog/price-change-approved_black.svg'  // '2715' Prisændring afvist
      case '14984':                                                                 // '14984' Mersalg oprettet
      case '1275': return 'images/svgs/invoicelog/additional-sales-new.svg'         // '1275' Mersalg ændret
    }
    icon = '/images/svgs/Cirkle_info-black.svg'
    return icon
  }
  getTextFromType (type) {
    return translation(type)
  }
  render () {
    let { item } = this.state
    if (item.MarkType === 2) {
      console.log('item invoice log ', item)
    }
    let type = this.getTextFromType(item.DictionaryKey)
    if (item.TextExtension !== undefined && item.TextExtension !== null) type += ' ' + item.TextExtension
    let date = ''
    if (item.Date && item.Date.length > 0) date = moment(window.CustomDate(item.Date)).format('DD-MM-YYYY - HH:mm')
    let name = ''
    if (item.UserName == null && item.CompanyName != null) {
      name = item.CompanyName
    }
    if (item.UserName != null) {
      name = item.UserName
    }
    let companyName = item.CompanyName
    let phone = item.UserPhone
    let mail = item.UserMail
    let showInfo = (companyName !== undefined && companyName != null && companyName.length > 0) ||
      (phone !== undefined && phone != null && phone.length > 0) || (mail !== undefined && mail != null && mail.length > 0)

    let price = <span />
    let hasVoucher = item.VoucherNo !== null
    let hasInvoice = item.InvoiceNo !== null
    let hasReportName = item.ReportName !== null
    let hasVoucherPath = item.VoucherFilePath !== null
    if (item.Price !== 0) {
      price = <span className='amount'>{formatCurrency(item.Price)} {this.props.currencyCode}</span>
    }
    // let imgsrc = this.findLogLineIcon(item.DictionaryKey)
    let imgsrc = makeOrderAssessmentIcon(item.DictionaryKey)
    let info = ''
    if (companyName != null) info += companyName
    if (phone != null) info += '\n' + phone
    if (mail != null) info += '\n' + mail
    let logClass = ''
    if (this.props.showColor === true) {
      if (item.MarkType === 1) logClass += ' green-box'
      if (item.MarkType === 2) logClass += ' blue-box'
    }
    let isWarning = item.IsWarning
    if (isWarning) logClass += ' red-box'

    const renderExtra = (type, extraNo) => {
      if (type === 'invoice' && !hasInvoice) return null
      if (type === 'voucher' && !hasVoucher) return null
      let title = translation('14970')
      if (type === 'voucher') title = translation('14971')
      if (type === 'voucher' && hasVoucher && hasVoucherPath) {
        return (
          <div>
            <div className='logtitle'>{title} </div>
            <a target='_BLANK' href={item.VoucherFilePath} ><div className='logname'>{extraNo}</div></a>
          </div>
        )
      }
      return (
        <LabelWrapper labelText={title}>
          <div>{extraNo}</div>
        </LabelWrapper>
      )
    }
    if (isWarning) {
      type = translation('534')
      name = translation('14986')
      showInfo = translation('14987')
      return (
        <Inline block alignChildren={'center'} fillChildNum={[1]}>
          <Icon icon={imgsrc} />
          <div className={logClass}>
            <LabelWrapper labelText={type}>
              <div>{name}</div>
              <div>{showInfo}</div>
            </LabelWrapper>
          </div>
        </Inline>
      )
    }
    // let logname = 'logname'
    // if (!showInfo) logname += ' wide'
    return (
      <Inline block alignChildren={'center'} fillChildNum={[1]}>
        <Icon icon={imgsrc} />
        <div className={logClass}>
          <Inline block alignChildren={'bottom'} fillChildNum={[0, 1]}>
            <LabelWrapper labelText={type}>
              <Inline block>
                <UserInfo user={item.UserInfo} />
                {showInfo && (
                  <HelpIcon helpText={info} white />
                )}
              </Inline>
              <div>{date}</div>
            </LabelWrapper>
            <span>
              {renderExtra('invoice', item.InvoiceNo)}
              {renderExtra('voucher', item.VoucherNo)}
              {hasReportName && (
                <span>{item.ReportName}</span>)}
            </span>
            {price}
          </Inline>
        </div>
      </Inline>
    )
  }

}
InvoiceLogItem.propTypes = {
  item: PropTypes.object.isRequired
}
function mapStateToProps (state) {
  return {
    auth: state.auth,
    currencyCode: state.common.currencyCode
  }
}

export default connect(mapStateToProps, {
})(InvoiceLogItem)



// WEBPACK FOOTER //
// ./src/app/pages/Orders/OrderList/NewItem/InvoiceLog/InvoiceLogItem/index.js